import { render, staticRenderFns } from "./SidebarItemLink.vue?vue&type=template&id=68520cb9"
import script from "./SidebarItemLink.vue?vue&type=script&lang=js"
export * from "./SidebarItemLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68520cb9')) {
      api.createRecord('68520cb9', component.options)
    } else {
      api.reload('68520cb9', component.options)
    }
    module.hot.accept("./SidebarItemLink.vue?vue&type=template&id=68520cb9", function () {
      api.rerender('68520cb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/SidebarItemLink.vue"
export default component.exports